import { render, staticRenderFns } from "./DetalheCronogramaAprovacao.vue?vue&type=template&id=4f5680a0&"
import script from "./DetalheCronogramaAprovacao.vue?vue&type=script&lang=js&"
export * from "./DetalheCronogramaAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports